/**
 * SINGLE source of truth for any public URL the app emits into:
 *   - <link rel="canonical">
 *   - <meta property="og:url">, og:image
 *   - JSON-LD `url`, `@id`, `mainEntityOfPage`
 *   - Sitemap loc tags rendered client-side
 *
 * Strict rule (P0): always derive from window.location.origin at runtime.
 * NEVER read REACT_APP_BACKEND_URL or any other env var here. Env vars are
 * baked at build time and can leak the API/preview origin into SEO surfaces.
 *
 * In SSR / test contexts where window is undefined we return an empty origin
 * so callers get a relative path; the production runtime always has window.
 *
 * @param {string} [path] - Path beginning with "/" (e.g. "/atlas/uk/acme").
 *   When omitted or empty, the current pathname is used.
 * @returns {string} Absolute URL like "https://answerwatch.com/atlas/uk/acme".
 */
export function getPublicUrl(path) {
  if (typeof window === "undefined" || !window.location) {
    return path || "";
  }
  const origin = window.location.origin;
  if (path === undefined || path === null || path === "") {
    return origin + window.location.pathname;
  }
  const normalised = path.startsWith("/") ? path : "/" + path;
  return origin + normalised;
}

/**
 * Same origin without a path. Useful for JSON-LD `publisher.url`,
 * `Organization.@id`, `WebSite.url`, etc.
 */
export function getPublicOrigin() {
  if (typeof window === "undefined" || !window.location) return "";
  return window.location.origin;
}
